<template>
    <div class="select-input">
        <div 
            v-if="label"
            class="label pl-3 pb-3 text weight-500"
        >
            {{ label }}
        </div>
        <v-select
            :class="{
              'select': color === 'white'
            }"
            hide-details
            v-model="model"
            :items="items"
            :label="placeholder"
            single-line
            :outlined="outlined"
            height="20"
        ></v-select>
    </div>
</template>

<script type="text/javascript">
  export default {
    props: {
        items: {
            type: Array,
            default: null,
        }, 
        label: {
            type: String,
            default: '',
        },
        placeholder: {
            type: String,
            default: '',
        },
        value: {
          type: String,
          default: '',
        },
        color: {
          type : String,
          default: '',
        },
        outlined: {
          type : Boolean,
          default: true,
        }
    },
    data() {
      return {
        message: "",
      }
    },
    computed: {
      model: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        },
      },
    },
  }
</script>


<style lang="scss">
    .select-input {
      .v-icon{ 
          color: $green-checked !important;
      }
      .label {
        color: darkgrey;
      }
      .select {
        background-color: #ffffff;
      }
      .v-select {
        margin-top: 13px;
        padding-top: 0px;
        padding: 5px;
        border-radius: 3px;
      }
      .v-input__slot:after {
        border-style: none !important;
      }

    }

</style>